import { useMemo } from 'react';
import 'date-fns/endOfWeek';
import 'date-fns/isSameDay';
import 'date-fns/isSameWeek';
import 'date-fns/isLastDayOfMonth';
import 'date-fns/isFirstDayOfMonth';
import 'date-fns/isWithinInterval';
import 'date-fns/startOfWeek';
import 'date-fns';
import 'tslib';
import 'date-fns/format';
import { getWeekDetails } from '../utils/getWeekDetails.js';

const useWeekPicker = (date, weekStartsOn) => {
    return useMemo(() => getWeekDetails(date, weekStartsOn), [date, weekStartsOn]);
};

export { useWeekPicker };
//# sourceMappingURL=useWeekPicker.js.map
